import swal from "sweetalert2";
<template>
  <div class="row">
    <!-- 标题-副标题 -->
    <div class="col-md-12">
      <h4 class="title">{{ title }}</h4>
      <p class="category">{{ category }}</p>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">{{ categorySecond }}</div>
      </div>

      <div class="card-body row">
        <!-- 分页 -->
        <div class="col-md-8">
          <el-select
            class="select-default"
            style="width: 6em"
            v-model="pagination.perPage"
            placeholder="Per page"
          >
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          &nbsp;
          <div style="display: inline-block">
            <el-select
              class="el-select"
              style="width: 8em"
              v-model="currentsearchType"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in searchType"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <div style="display:inline-block">
              <fg-input
                class="input-sm"
                placeholder="搜索"
                v-model="searchQuery"
                @keyup.enter="getData"
              >
              </fg-input>
            </div>
            <p-button @click="getData">搜索</p-button>
          </div>
          <!--          <div style="display:inline-block">-->
          <!--            <el-date-picker-->
          <!--              v-model="selectTime"-->
          <!--              type="datetimerange"-->
          <!--              :picker-options="pickerOptions2"-->
          <!--              range-separator="至"-->
          <!--              start-placeholder="开始日期"-->
          <!--              end-placeholder="结束日期"-->
          <!--              align="right"-->
          <!--              value-format="yyyy-MM-dd HH:mm:ss">-->
          <!--            </el-date-picker>-->
          <!--          </div>-->
        </div>

        <!--搜索 -->
        <div class="col-sm-4">
          <div class="pull-right">
            <div>
              <el-switch
                style="display: block"
                v-model="is_lock"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="显示锁定渠道"
                inactive-text="不显示锁定渠道"
              >
              </el-switch>
              <el-switch
                style="display: block"
                v-model="is_update"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="显示更新"
                inactive-text="显示正常"
              >
              </el-switch>
            </div>
            <p-button
              type="info"
              plain
              @click="channel_lock"
              :disabled="lock_disable"
              v-if="!is_lock"
            >
              锁定渠道号
            </p-button>
            <p-button
              type="info"
              plain
              @click="channel_lock"
              :disabled="lock_disable"
              v-else-if="is_lock"
            >
              解锁渠道号
            </p-button>
            <p-button
              type="info"
              plain
              @click="updateAPI"
              :disabled="my_disable"
            >
              更新
            </p-button>
            <p-button type="info" plain @click="requestBackPathAPI">
              下载excel
            </p-button>
          </div>
        </div>

        <!-- 表格 -->
        <div class="col-sm-12 mt-2">
          <el-table
            class="table-striped"
            :data="queriedData"
            border
            @selection-change="handleSelectionChange"
            style="width: 100%"
          >
            <el-table-column type="selection" v-model="course" fixed>
            </el-table-column>
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            >
            </el-table-column>
            <el-table-column
              :min-width="450"
              class-name="td-actions"
              label="操作"
            >
              <template slot-scope="props">
                <p-button
                  type="danger"
                  size="sm"
                  @click="downloadResource(props.row.address)"
                  v-if="props.row.address"
                >
                  <i>资源下载</i>
                </p-button>
                <p-button
                  type="danger"
                  size="sm"
                  @click="copyDoenloadUrl(props.row.address, $event)"
                  v-if="props.row.address"
                >
                  <i>复制下载链接</i>
                </p-button>
                <p-button
                  type="danger"
                  size="sm"
                  @click="copyAlignmenUrl(props.row.alignmen_address, $event)"
                  v-if="props.row.alignmen_address"
                >
                  <i>复制联调链接</i>
                </p-button>
                <p-button
                  type="danger"
                  size="sm"
                  @click="packageLog(props.row.id)"
                >
                  <i>操作历史</i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 底部 -->
        <div class="col-sm-6 pagination-info">
          <p class="category">{{ page }}</p>
        </div>
        <div class="col-sm-6">
          <p-pagination
            class="pull-right"
            v-model="pagination.currentPage"
            :page-count="pagination.page_count"
          >
          </p-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="操作日志" :visible.sync="dialogLogVisible">
      <el-table :data="LogTablesData">
        <el-table-column
          v-for="column in logColumns"
          :key="column.label"
          :min-width="column.minWidth"
          :prop="column.prop"
          :label="column.label"
        >
        </el-table-column>
        <div slot="footer" class="dialog-footer">
          <div class="btn-group">
            <p-button type="info" round @click="dialogLogVisible = false"
              >取 消</p-button
            >
            <p-button type="info" round>确 定</p-button>
          </div>
        </div>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import swal from "sweetalert2";
import clip from "src/util/clipboard";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import Search from "src/components/UIComponents/Search/Search.vue";
import { getFetch } from "src/util/fetch";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
  watch: {
    "pagination.perPage"() {
      this.getData();
    },
    "pagination.currentPage"() {
      this.getData();
    },
    is_lock() {
      this.getData();
    },
    is_update() {
      this.getData();
    }
  },
  components: {
    PPagination,
    Search
  },
  computed: {
    queriedData() {
      return this.tableData;
    },
    to() {
      if (this.pagination.perPage !== "ALL") {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      } else {
        return this.total;
      }
    },
    from() {
      return this.pagination.perPage === "ALL"
        ? 0
        : this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      // this.changeTotal(this.total_count)
      return this.total_count;
    },
    page() {
      return `从 ${this.from + 1} 到 ${this.to} 共 ${this.total} 条`;
    }
  },
  data() {
    //定义tabel
    return {
      is_lock: false,
      is_update: false,
      lock_disable: false,
      floor: "jssy",
      my_disable: false,
      title: "第四事业部推广包历史记录",
      category: "",
      categorySecond: "",
      selectTime: "", //选择的开始时间和结束时间
      LogTablesData: [],
      dialogFormVisible: false,
      dialogLogVisible: false,
      multipleTable: [], //存放选中值的数组
      updateIds: [], //选中的更新游戏编号
      pagination: {
        //分页
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 20, "ALL"],
        page_count: 0,
        total: 0
      },
      searchQuery: "", //搜索值
      currentsearchType: "游戏id",
      searchType: ["游戏id", "游戏名", "操作者", "渠道号"], //搜索字段
      // typeInfo:{
      //   "游戏id":"gid",
      //   "游戏名":"name",
      //   "操作者":"user",
      //   "渠道号":"channel"
      // },
      tableColumns: [
        //列表
        {
          prop: "id",
          label: "编号",
          minWidth: 100
        },
        {
          prop: "gameid",
          label: "游戏id",
          minWidth: 100
        },
        {
          prop: "child_game_name",
          label: "游戏名",
          minWidth: 200
        },
        {
          prop: "floor",
          label: "事业部",
          minWidth: 120
        },
        {
          prop: "target_version",
          label: "targetSDK",
          minWidth: 75
        },
        {
          prop: "chennel_category",
          label: "渠道分组",
          minWidth: 100
        },
        {
          prop: "chennel",
          label: "渠道号",
          minWidth: 200
        },
        {
          prop: "is_lock",
          label: "渠道是否锁定",
          minWidth: 120
        },
        {
          prop: "result",
          label: "打包状态",
          minWidth: 100
        },
        {
          prop: "cdn_result",
          label: "CDN刷新状态",
          minWidth: 100
        },
        {
          prop: "status",
          label: "马甲包状态",
          minWidth: 100
        },
        {
          prop: "apk_size",
          label: "包体大小",
          minWidth: 100
        },
        {
          prop: "Ptime",
          label: "打包时间",
          minWidth: 200
        },
        {
          prop: "user",
          label: "操作者",
          minWidth: 100
        }
      ],
      logColumns: [
        {
          prop: "gameid",
          label: "游戏id",
          minWidth: 50
        },
        {
          prop: "child_game_name",
          label: "游戏名",
          minWidth: 50
        },
        {
          prop: "floor",
          label: "事业部",
          minWidth: 50
        },
        {
          prop: "target_version",
          label: "targetSDK",
          minWidth: 75
        },
        {
          prop: "chennel_category",
          label: "渠道分组",
          minWidth: 50
        },
        {
          prop: "chennel",
          label: "渠道号",
          minWidth: 50
        },
        {
          prop: "result",
          label: "打包状态",
          minWidth: 50
        },
        {
          prop: "status",
          label: "马甲包状态",
          minWidth: 50
        },
        {
          prop: "apk_size",
          label: "包体大小",
          minWidth: 50
        },
        {
          prop: "Ptime",
          label: "打包时间",
          minWidth: 50
        },
        {
          prop: "user",
          label: "操作者",
          minWidth: 50
        }
      ],
      tableData: [], //渲染table数据

      //获取游戏信息批量传输给后台
      course: [],
      total_count: 0,
      pageTemp: 0,

      pickerOptions2: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    packageLog(id) {
      this.dialogLogVisible = true;
      this.getLog(id);
    },
    async getLog(pid) {
      let opt = {
        url: "/api/apk/log_jspackage/",
        type: "GET",
        data: {
          pid: pid
        }
      };
      const res = await getFetch(this, opt);
      if (res.code == 0) {
        let list = [];
        if (res.data.genpacking_log) {
          for (var i = 0; i < res.data.genpacking_log.length; i++) {
            var data = res.data.genpacking_log[i];
            if (data.result === -1) {
              data.result = "正在打包";
            } else if (data.result === 1) {
              data.result = "成功";
            } else if (data.result === 2) {
              data.result = "正在上传oss存储";
            } else {
              data.result = "失败";
            }
            if (data.floor == "sypt") {
              data.floor = "第一事业部";
            } else if (data.floor == "yypt") {
              data.floor = "第二事业部";
            } else {
              data.floor = "第四事业部";
            }
            list.push(data);
          }
        }
        this.LogTablesData = list;
      }
    },
    handleSelectionChange(val) {
      this.multipleTable = val; //  this.multipleTable 选中的值
    },

    //资源下载
    downloadResource(url) {
      open(url);
    },
    //复制下载地址
    copyDoenloadUrl(text, event) {
      clip(text, event);
    },
    //复制监测链接
    copyAlignmenUrl(text, event) {
      clip(text, event);
    },
    cractAccount() {
      this.dialogFormVisible = true;
    },
    changeTotal(length) {
      this.pagination.total = length;
    },
    async getData(page, size) {
      page = this.pagination.currentPage;
      size = this.pagination.perPage;
      // name = this
      // type = this
      // gid = this
      let req_data = {};
      req_data["is_lock"] = this.is_lock ? 1 : 0;
      req_data["is_update"] = this.is_update ? "更新" : "正常";
      size !== "ALL" ? (req_data["size"] = size) : "";
      req_data["page"] = this.searchQuery
        ? this.pageTemp === 0
          ? 1
          : page
        : page;
      if (this.searchQuery !== "") {
        if (this.currentsearchType === this.searchType[0]) {
          req_data["type"] = 1;
          req_data["gid"] = this.searchQuery;
        } else if (this.currentsearchType === this.searchType[1]) {
          req_data["type"] = 2;
          req_data["name"] = this.searchQuery;
        } else if (this.currentsearchType === this.searchType[2]) {
          req_data["type"] = 4;
          req_data["user"] = this.searchQuery;
        } else if (this.currentsearchType === this.searchType[3]) {
          req_data["type"] = 5;
          req_data["channel"] = this.searchQuery;
        }
      }
      if (this.selectTime != "") {
        req_data["type"] = 3;
        req_data["start_time"] = this.selectTime[0];
        req_data["end_time"] = this.selectTime[1];
      }

      let opt = {
        url: "/api/apk/jspackage_histroy/",
        type: "GET",
        data: req_data
        //  如果需要接入第三方的接口，需要添加此参数
        // host:window.Config.homeHost
      };
      // console.log(req_data)
      const res = await getFetch(this, opt);
      if (res.code === 0) {
        console.log(res.data);
        var list = [];
        if (res.data.package_informations.results) {
          for (
            var i = 0;
            i < res.data.package_informations.results.length;
            i++
          ) {
            var data = res.data.package_informations.results[i];
            if (data.result === -1) {
              data.result = "正在打包";
            } else if (data.result === 1) {
              data.result = "成功";
            } else if (data.result === 2) {
              data.result = "正在上传";
            } else {
              data.result = "失败";
            }
            if (data.floor == "sypt") {
              data.floor = "第一事业部";
            } else if (data.floor == "yypt") {
              data.floor = "第二事业部";
            } else {
              data.floor = "第四事业部";
            }

            if (data.cdn_result) {
              data.cdn_result = "成功";
            } else {
              data.cdn_result = "失败";
            }
            if (data.is_lock) {
              data.is_lock = "锁定";
            } else {
              data.is_lock = "正常";
            }
            list.push(data);
          }
          this.tableData = list; //res.data.package_informations.results
          //console.log(this.tableData)
          this.changeTotal(res.data.package_informations.total_count);
          this.total_count = res.data.package_informations.total_count;
          this.pageTemp = this.total_count;
          this.pagination.page_count = res.data.package_informations.total_page;
          // this.searchQuery = ""
        } else if (
          this.searchQuery ||
          this.selectTime ||
          !res.data.package_informations.results
        ) {
          this.searchQuery = "";
          this.selectTime = "";
          this.tableData = [];
        }
      }
    },
    async channel_lock() {
      if (this.multipleTable.length > 0) {
        switch (this.is_lock) {
          case true:
            swal({
              title: "确定要解锁渠道？",
              type: "warning",
              showCancelButton: true,
              confirmButtonClass: "btn btn-success btn-fill",
              cancelButtonClass: "btn btn-danger btn-fill",
              confirmButtonText: "是",
              cancelButtonText: "否",
              buttonsStyling: false
            }).then(() => {
              this.dochannel_lock();
            });
            break;
          case false:
            swal({
              title: "确定要锁定渠道？",
              type: "warning",
              showCancelButton: true,
              confirmButtonClass: "btn btn-success btn-fill",
              cancelButtonClass: "btn btn-danger btn-fill",
              confirmButtonText: "是",
              cancelButtonText: "否",
              buttonsStyling: false
            }).then(() => {
              this.dochannel_lock(true);
            });
            break;
        }
      } else {
        alert("请选择渠道再进行操作！");
      }
    },
    async dochannel_lock(is_lock = false) {
      for (var k = 0; k < this.multipleTable.length; k++) {
        this.updateIds.push(this.multipleTable[k].chennel);
      }
      let opt = {
        url: "/api/apk/lock_channel/",
        type: "post",
        data: {
          channel: this.updateIds,
          floor: this.floor
        }
      };
      const res = await getFetch(this, opt);
      if (res.code === 0) {
        switch (is_lock) {
          case true:
            swal({
              title: "渠道锁定成功!",
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            }).then(() => {
              this.is_lock = false;
              this.getData();
            });
            this.updateIds = [];
            break;
          case false:
            swal({
              title: "渠道解锁成功!",
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            }).then(() => {
              this.is_lock = false;
              this.getData();
            });
            this.updateIds = [];
            break;
        }
      } else {
        this.updateIds = [];
      }
    },

    //更新
    async updateAPI() {
      this.updateIds = [];
      for (var i = 0; i < this.multipleTable.length; i++) {
        this.updateIds.push(this.multipleTable[i].id);
      }

      let opt = {
        url: "/api/apk/packing/",
        type: "put",
        data: {
          floor: this.floor,
          args: this.updateIds
        }
      };
      if (this.updateIds.length !== 0) {
        this.my_disable = "";
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          alert("正在进行更新");
          this.my_disable = false;
          this.getData();
        }
      }
    },

    //请求返回path
    async requestBackPathAPI() {
      this.updateIds = [];
      for (var i = 0; i < this.multipleTable.length; i++) {
        this.updateIds.push(this.multipleTable[i].id);
      }
      //console.log(this.updateIds)

      let opt = {
        url: "/api/apk/create_excel/",
        type: "post",
        data: {
          idlist: this.updateIds,
          floor: this.floor
        }
      };
      if (this.updateIds.length !== 0) {
        const res = await getFetch(this, opt);
        //console.log(res)
        if (res.code === 0) {
          //下载Excel
          open(window.Config.host + "/download" + res.path);
        }
      } else {
        alert("请选择记录下载");
      }
    }
  },
  mounted() {
    this.getData();
  }
};
</script>
